import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import React, {useEffect, useRef, useState} from "react";
import {getFireStatusType} from "../../api/apiClient";


const ComboFireStatus = ({
                           propLabel = '화재상태',
                           propDefault = '화재종료',
                           propIsReadonly = false,
                           propOnChange = null,
                           propValue = null,
                           propLocation = "SEARCH"
                         }) => {


  /* 자치구 목록 data */
  const [stFireStatusList, setFireStatusList] = useState([]);
  /* 자치구 목록 갱신 */
  const updateList = () => {
    getFireStatusType()
        .then((res) => {
              setFireStatusList(res.data.data.list);
            }
        );
  };

  useEffect(() => {
    updateList();
  }, []);

  useEffect(() => {
    console.log(propValue);
  }, [propValue]);


  const selBox = useRef();
  useEffect(() => {
    for (let i = 0; i < stFireStatusList.length; i++) {
      if (propDefault === selBox.current[i].label) {
        selBox.current.value = i;
      }

    }
  }, [stFireStatusList]);

  return (
      /*<Form.Group as={Row} controlId="formBasicSelectMenu">
        <Form.Label column sm={3} className={`label text-end ${propLocation === "FIELD" ? "fw-bold" : ''}`}>
          {propLocation === "FIELD" ? <span className={"text-danger"}>* </span> : ''}{propLabel}
        </Form.Label>
        <Col sm={9} className={""}>
          <Form.Select
              aria-label="Districts Select"
              className={"input input-select"}
              onChange={propOnChange}
              ref={selBox}
              defaultValue={propValue}
              key={propValue}
          >
            {propLocation === "SEARCH" ? <option value={""}>전체</option> : ''}
            {Array.isArray(stFireStatusList) ?
                (stFireStatusList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>*/
      <Form.Group as={Row} controlId="formBasicSelectMenu">
        {/*<Form.Label column sm={3} className={`label text-end ${propLocation === "FIELD" ? "fw-bold" : ''}`}>*/}
        <Form.Label
            className={`col-form-label label text-end d-inline-block ${propLocation === "FIELD" ? "fw-bold" : ""} `}
            style={propLocation === "FIELD" ? {} : {width: "100px"}}
            column={propLocation === "FIELD" ? true : false}
            sm={propLocation === "FIELD" ? 3 : ''}
        >
          {propLocation === "FIELD" ? <span className={"text-danger"}>* </span> : ''}{propLabel}
        </Form.Label>
        <Col md={propLocation === "FIELD" ? 9 : ''} className={""}>
          <Form.Select
              aria-label="Districts Select"
              className={"input input-select"}
              onChange={propOnChange}
              ref={selBox}
              defaultValue={propValue}
              key={propValue}
          >
            {propLocation === "SEARCH" ? <option value={""}>전체</option> : ''}
            {Array.isArray(stFireStatusList) ?
                (stFireStatusList.map((elem, idx) => {
                  return (
                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                  )
                })) : ''}
          </Form.Select>
        </Col>
      </Form.Group>
  );
}

export default ComboFireStatus;
